import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { createAppRouter } from "@/router";
import { prepareAuthCallback } from "@/lib/auth/synaptic-identity";
import "@/app/globals.css";
import "@custom-packages/ui/dist/style.css";
import "@custom-packages/paywall/style.css";

const callbackRedirect = prepareAuthCallback(window.location.href, window.localStorage);
if (callbackRedirect) {
  window.history.replaceState(null, "", callbackRedirect);
}

const router = createAppRouter();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>,
);
